module.exports = __webpack_public_path__ + "c_static/img/Share-QR-code_img_fingerprint_default@2x.f65863b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/Share-QR-code_img_fingerprint_default@2x.png
// module id = P8bz
// module chunks = 33